import React from 'react';
import './PrivacyPolicy.css';

function PrivacyPolicy() {
  return (
    <div className="policy-container">
      <div className="policy-content">
        <h1>Privacy Policy</h1>
        {/* <p><strong>Effective Date:</strong> May 25, 2024</p> */}

        <h2>1. Introduction</h2>
        <p>
          Airrived Inc. (“Company,” “we,” “us,” or “our”) is committed to respecting and protecting your privacy.
          This Privacy Policy explains how we collect, use, store, and share your personal information when you use our website, software, and related services (“Services”).
        </p>

        <h2>2. Information We Collect</h2>
        <h3>Information You Provide:</h3>
        <p>
          We collect the information you provide when you create an account, complete forms, or communicate with us.
          This may include your name, email address, payment information, and any other information you choose to provide.
        </p>
        <h3>Information from Your Use of the Services:</h3>
        <p>
          We automatically collect information about how you use our Services, such as IP address, device information, browser type, and pages visited.
        </p>
        <h3>Cookies and Similar Technologies:</h3>
        <p>
          We use cookies and similar tracking technologies to personalize and improve your experience.
          You can manage your cookie preferences through your browser settings.
        </p>

        <h2>3. How We Use Your Information</h2>
        <ul>
          <li>Provide, maintain, and improve our Services.</li>
          <li>Process your transactions and send you related information.</li>
          <li>Communicate with you, including sending service-related announcements or promotional messages.</li>
          <li>Monitor and analyze usage trends to improve user experience.</li>
          <li>Comply with legal obligations and protect our legal rights.</li>
        </ul>

        <h2>4. Sharing and Disclosure of Information</h2>
        <p>We will not share your personal information with third parties except in the following circumstances:</p>
        <ul>
          <li><strong>Service Providers:</strong> We may share information with vendors, consultants, and other service providers who perform services on our behalf.</li>
          <li><strong>Business Transfers:</strong> In the event of a merger, acquisition, financing, or sale of assets, your information may be transferred to a third party.</li>
          <li><strong>Legal Compliance:</strong> We may share information when required by law or to protect our rights and the safety of our users.</li>
          <li><strong>With Your Consent:</strong> We may share information in other ways if we have obtained your explicit consent to do so.</li>
        </ul>

        <h2>5. Data Retention</h2>
        <p>
          We retain your information for as long as necessary to provide the Services, comply with legal obligations, resolve disputes, and enforce our agreements.
          If you request deletion of your information, we will take reasonable steps to delete it, unless we are required to keep it by law.
        </p>

        <h2>6. Data Security</h2>
        <p>
          We implement reasonable technical and organizational measures to protect your data against loss, unauthorized access, disclosure, alteration, or destruction.
          However, no method of transmission over the internet or electronic storage is completely secure.
        </p>

        <h2>7. International Data Transfers</h2>
        <p>
          Your information may be transferred to and maintained on servers located in a jurisdiction different from your own.
          If you are located outside the region where our servers are hosted, note that we may transfer your personal information to a country and jurisdiction that does not have the same data protection laws as your jurisdiction.
        </p>

        <h2>8. Children’s Privacy</h2>
        <p>
          Our Services are not intended for individuals under the age of 13 (or the age of majority in your jurisdiction).
          We do not knowingly collect personal information from children.
          If you believe a child under the applicable age has provided personal information, please contact us immediately so we can delete such information.
        </p>

        <h2>9. Your Rights</h2>
        <p>
          Depending on your jurisdiction, you may have certain rights regarding your personal data, such as the right to access, correct, update, or delete your personal information.
          If you wish to exercise these rights, please contact us using the details below.
        </p>

        <h2>10. Third-Party Links</h2>
        <p>
          Our Services may include links to third-party websites or services.
          We are not responsible for the content, privacy practices, or security of any third-party websites or services.
          We encourage you to review the privacy policies of these third parties before providing any personal information to them.
        </p>

        <h2>11. Changes to This Privacy Policy</h2>
        <p>
          We may update this Privacy Policy from time to time.
          If we make material changes, we will notify you by posting a notice on our website or by other appropriate means.
          Your continued use of the Services after any such changes indicates your acceptance of the revised Privacy Policy.
        </p>

        <h2>12. Contact Us</h2>
        <p>
          If you have any questions or concerns regarding this Privacy Policy, please contact us at:
        </p>
        <p><strong>Email:</strong> support@airrived.ai</p>

        {/* <p className="disclaimer">
          <strong>Disclaimer:</strong> This sample Privacy Policy is provided for informational purposes only and does not constitute legal advice.
          Laws and regulations vary by jurisdiction, and you should consult with an attorney to ensure your legal documents are accurate, complete, and comply with all applicable regulations.
        </p> */}
      </div>
    </div>
  );
}

export default PrivacyPolicy;